import type { Rule } from 'antd/lib/form';

export const FIRST_NAME_REQUIRED_MESSAGE = 'Enter your first name.';
export const LAST_NAME_REQUIRED_MESSAGE = 'Enter your last name.';

// A name that is missing, empty, or white space only is rejected. The value is
// not changed: "mohammad reza" and " Ada " are sent as typed.
const notBlank = (message: string): Rule[] => [
  {
    validator: (_rule, value) =>
      typeof value === 'string' && /\S/.test(value) ? Promise.resolve() : Promise.reject(new Error(message)),
  },
];

const firstNameRules = notBlank(FIRST_NAME_REQUIRED_MESSAGE);
const lastNameRules = notBlank(LAST_NAME_REQUIRED_MESSAGE);

// The rules of the two name fields of the account setup forms. Every other
// field has no rule here.
export const signUpNameRules = (fieldKey: string): Rule[] | undefined => {
  switch (fieldKey) {
    case 'firstName':
      return firstNameRules;
    case 'lastName':
      return lastNameRules;
    default:
      return undefined;
  }
};
